import { render, staticRenderFns } from "./NotificationCircle.vue?vue&type=template&id=d713dae2&scoped=true&"
import script from "./NotificationCircle.vue?vue&type=script&lang=js&"
export * from "./NotificationCircle.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCircle.vue?vue&type=style&index=0&id=d713dae2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d713dae2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d713dae2')) {
      api.createRecord('d713dae2', component.options)
    } else {
      api.reload('d713dae2', component.options)
    }
    module.hot.accept("./NotificationCircle.vue?vue&type=template&id=d713dae2&scoped=true&", function () {
      api.rerender('d713dae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Elements/NotificationCircle.vue"
export default component.exports